// 实习版
export const internService = [
  {
    title:'简历优化',
    desc:'从用人方角度出发，逐字逐句打造被 HR 瞬间 Pick 的好简历',
    descTips:'专业 HR 执笔，最大程度满足凸显用户特点和高度匹配岗位；往期平均投递后2-3天内收到面试邀请',
    type:'cv_optimization',
    count: "18,266",
    imgSrc: 'https://files.wondercv.com/PC/mentor/intern/service1.png'
  },{
    title:'面试辅导',
    desc:'行业大牛语音辅导，好 Offer 就是要一遍抓住',
    dialogDesc: '行业大牛语音辅导，好 Offer 就是要一遍抓住',
    descTips:'30 分钟深度沟通，关于面试你想知道的，我们都会告诉你',
    type:'interview_guidance',
    count: "877,193",
    iconSrc: 'https://files.wondercv.com/PC/mentor/tuijian.png',   //修改图片
    imgSrc: 'https://files.wondercv.com/PC/mentor/intern/service2.png'
  }
  // ,{
  //   title:'专业测试',
  //   desc:'职业生涯规划和定位测试，附赠详细测评报告解析',
  //   descTips:'实习之前找准方向，打好职业生涯起点。本测试采用腾讯阿里及其他 500 强等头部企业最常用的职业测试题库',
  //   type:'professional_test',
  // },
]
// 校招版
export const campusService = [
  {
    title:'简历优化',
    desc:'从用人方角度出发，逐字逐句打造被 HR 瞬间 Pick 的好简历',
    descTips:'专业 HR 执笔，最大程度满足凸显用户特点和高度匹配岗位；平均提升4倍以上的投递通过率',
    type:'cv_optimization',
    count: "18,266",
    imgSrc: 'https://files.wondercv.com/PC/mentor/college/service1.png'
  },{
    title:'面试辅导',
    desc:'知名企业资深校招招聘负责人，1V1 语音沟通',
    dialogDesc: '知名企业资深校招招聘负责人，1V1 语音沟通',
    descTips:'60 分钟深度沟通，5 道自选面试问题+3 道个性化面试题+2 道预测面试题，为你的 Offer 保驾护航',
    type:'interview_guidance',
    count: "877,193",
    iconSrc: 'https://files.wondercv.com/PC/mentor/tuijian.png',
    imgSrc: 'https://files.wondercv.com/PC/mentor/college/service2.png'
  },{
    title:'面试模拟',
    desc:'模拟面试+深度复盘，精准挖掘面试弱点',
    descTips:'15 分钟模拟面试，45 分钟深度面试复盘，给自己一次面试模拟考',
    type:'interview_simulation',
    count: "372,629",
    imgSrc: 'https://files.wondercv.com/PC/mentor/college/service3.png'
  },{
    title:'职业规划',
    desc:'职业规划师为你量身打造职场晋升之路，打好职场第一步',
    descTips:'解答职业困惑，制定职业发展计划及阶段性目标',
    type:'career_plan',
    count: "901,542",
    imgSrc: 'https://files.wondercv.com/PC/mentor/college/service4.png'
  }
  // ,{
  //   title:'专业测试',
  //   desc:'职业生涯规划和定位测试 + MBTI测试，附赠详细测评报告解析',
  //   descTips:'采用腾讯阿里及其他 500 强等头部企业最常用的职业测试题库',
  //   type:'professional_test',
  // },
]
// 在职版
export const fullService = [
  {
    title:'简历优化',
    desc:'从用人方角度出发，逐字逐句打造被 HR 瞬间 Pick 的好简历',
    descTips:'专业 HR 执笔，最大程度满足凸显用户特点和高度匹配岗位；平均提升120%以上的面试邀约率',
    type:'cv_optimization',
    count: "18,266",
    imgSrc: 'https://files.wondercv.com/PC/mentor/working/service1.png'
  },{
    title:'面试辅导',
    desc:'往期用户平均面试通过率翻倍，拿 Offer 更容易',
    dialogDesc: '往期用户平均面试通过率翻倍，拿 Offer 更容易',
    descTips:'60 分钟深度沟通，5 道自选面试问题 +3 道个性化面试题+2 道预测面试题，为你的 Offer 保驾护航',
    type:'interview_guidance',
    count: "877,193",
    iconSrc: 'https://files.wondercv.com/PC/mentor/tuijian.png',
    imgSrc: 'https://files.wondercv.com/PC/mentor/working/service2.png'
  },{
    title:'面试模拟',
    desc:'模拟面试+深度复盘，精准挖掘面试弱点',
    descTips:'30 分钟模拟面试，60 分钟深度面试复盘',
    type:'interview_simulation',
    count: "372,629",
    imgSrc: 'https://files.wondercv.com/PC/mentor/working/service3.png'
  },{
    title:'职业规划',
    desc:'职业规划师为你量身打造职场晋升之路，明确发展方向',
    descTips:'解答职业困惑，整合优势抓住周期，实现弯道超车',
    type:'career_plan',
    count: "901,542",
    imgSrc: 'https://files.wondercv.com/PC/mentor/working/service4.png'
  }
  // ,{
  //   title:'专业测试',
  //   desc:'MBTI+职业锚深度测试，附赠详细测评报告解析',
  //   descTips:'采用华为阿里及其他 500 强等头部企业最常用的职业测试题库',
  //   type:'professional_test'
  // },
]
export const serviceOptions = {
  education:[
    {
      label:'IT/互联网',
      value:0,
    },{
      label:'咨询/金融/四大/商业分析',
      value:1,
    },{
      label:'广告/传媒',
      value:2,
    },{
      label:'快消/贸易',
      value:3,
    },{
      label:'教育/培训',
      value:4,
    },{
      label:'房地产/建筑',
      value:5,
    },{
      label:'其他',
      value:6,
    },
  ]
}
{/* <p>1.5 专业测试：指我方向您提供的用于进行职业评估的测试题，包括线上及线下测试</p> */}
export const snameContent = `
<p>欢迎您选择超级简历（“我司”）提供的导师辅导服务，为使您顺利完成本次服务， 请您认真阅读以下本《导师辅导服务协议》（以下简称“本协议”）。在您购买本产品之前， 请您审慎阅读、充分理解本协议，您一旦购买导师辅导的任何服务，即视为您同意本协议全部内容； 如果您不同意本协议，则请勿购买导师辅导服务。本协议构成对双方有约束力的法律文件。</p>

<p>一.术语含义</p>
<p>1.1. 用户/您：指同意本协议并购买简历服务的用户。</p>
<p>1.2.HR老师/猎头专家/导师：指向用户提供简历服务的人员。</p>
<p>1.3 简历服务：指导师向用户提供的简历修改服务</p>
<p>1.4 1v1服务：指除简历服务外，「面试辅导」「面试模拟」「职业规划」等语音沟通的服务</p>

<p>二.服务内容</p>
<p>2.1.在您完成付款后即为成功购买导师辅导服务。HR老师/猎头专家将在工作日24小时内主动与您取得联系，指导您完成简历优化工作。简历服务自下单之日起有效期30天，1V1服务自下单之日起有效期60天。请在有效期内使用服务。服务期内未使用服务则服务自动失效，请您合理安排自己的时间。</p>
<p>2.2.请您理解并知悉HR老师/猎头专家将尽职为您提供优质的服务，但本产品并不保证产品效果， 如您因操作失误或其他个人原因希望结束服务退还服务费用，请在HR老师/猎头专家与您进行简历优化沟通前提出。 一旦导师对于您的简历提供了简历初稿，即视为服务已开始，服务开始后将不再支持退费申请。</p>
<p>2.3.HR老师/猎头专家将在完成和您的第一次沟通之日起3个工作日内出第一版简历。如您不满意第一版简历， 请在收到第一版简历后的7日内提出申请，我司将为您免费提供一次重新优化或更换HR老师猎头专家的机会； 如超过7日未提出申请将视为您已确认服务，本次服务完成。若您仍希望HR老师/猎头专家继续为您提供服务，您需要另行支付费用。</p>
<p>2.4. 如您购买的产品包含职业规划、薪资谈判、面试技巧等辅导，而您对这些辅导不满意， 请自HR老师/猎头专家为您完成辅导之日起7日内提出申请，我司将为您免费提供一次更换HR老师/猎头专家的机会； 如超过7日未提出申请将视为您已确认服务，本次服务完成。若您仍希望HR老师/猎头专家继续为您提供服务，您需要另行支付费用。</p>
<p>2.5.HR老师/猎头专家将通过电话或者微信方式与您联系沟通。</p>
<p>2.6.您应保证您的注册信息、提供给HR老师/猎头专家的简历信息真实、准确、合法、完整，因您提供的信息违反上述约定导致的问题，由您自行承担，与我司无关。</p>
<p>三.服务的购买</p>
<p>3.1. 价格及使用期间</p>
<p>本服务的价格受市场环境的影响不同时期可能存在价格变化， 您所购买服务的价格应以您在简历优化页面获取的订单中显示的内容为准。 一旦您完成支付，即视为您已认可本服务标明之价格及使用期间的约定。</p>
<p>3.2.支付方式</p>
<p>超级简历已为您开通：微信、支付宝支付渠道，请您妥善保存并使用您的支付密码， 超级简历不对任何由个人操作不当泄露第三方支付账号、密码等原因导致的财产损失负责。</p>
<p></p>
<p>四.个人信息保护</p>
<p>本服务由超级简历合作的第三方公司提供，为方便向您提供导师辅导服务，超级简历会向HR老师/猎头专家提供您预留的个人信息 （个人信息包括您的姓名、电话号码及微信号）。您在向HR老师/猎头专家提供简历前， 请注意将与导师辅导服务不相关的或者不必要的信息进行遮挡。导师辅导服务开始前，可能需要您进行一些准备工作，以方便HR老师/猎头专家能够更好的服务您。</p>
<p>请注意：HR老师/猎头专家在服务期间不会提及身份证号及银行卡号等信息。 如果遇到HR老师/猎头专家要求您提供个人身份证号及银行卡号等信息，请勿透露，并及时通知超级简历客服进行处理。</p>
<p>五.免责声明</p>
<p>HR老师/猎头专家最终为您优化的简历，严格以您提供的简历信息为准，您将自行为简历的真实性负责。 优化后的简历仅供用您考使用，为保证更好的求职效果，建议您以HR老师/猎头专家建议为基础进行进一步优化补充。 HR老师/猎头专家的建议不能视为我司立场和观点，也不具有任何法律效力。 您理解并知悉offer的取得受招聘市场及招聘单位的用人需求、您个人求职表现等多重因素的影响， 本服务并不承诺您在进行简历优化后一定能接到offer或接到您心仪的offer。</p>
<p>六.其他</p>
<p>6.1. 如我司发现您在使用本产品过程中存在任何违反法律法规、超级简历《用户协议》、《隐私政策》、《法律声明》及本协议约定的，我司有权终止您对本产品的使用。</p>
<p>6.2.我司有权修改本协议条款，一旦本协议内容发生变动，我司将在本网站上公布修改后的协议内容。 如果您不同意修改后的协议，您应立即停止使用本产品；如您继续使用本产品，则视为您接受修改后的协议。</p>
<p>6.3.本产品最终解释权归超级简历所有。</p>
`